import React from "react";
import { InputAdapter } from "./InputAdapter";
import type { InputAdapterProps } from "./InputAdapter";
import {inputType} from "./inputConstants";

export const EmailField: React.FC<InputAdapterProps> = (props) => {
    return <InputAdapter {...props} inputType={inputType.EMAIL}/>;
};
